import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Budget, Budgets, BudgetPayload } from '../interfaces/budget';
import { catchError, map, Observable, throwError } from 'rxjs';
import { BASEURL } from '../constant/url';

@Injectable({
  providedIn: 'root',
})
export class BudgetService {
  private readonly _http = inject(HttpClient);

  fetchBudgets(page: number, pageSize?: number, query?: string): Observable<Budgets> {
    let url = `${BASEURL}budgets?sort=id:desc&pagination[page]=${page}&pagination[pageSize]=${pageSize || 10}`;
    if (query) {
      url += `&filters[$or][0][description][$containsi]=${encodeURIComponent(query)}&filters[$or][1][address][$containsi]=${encodeURIComponent(query)}`;
    }
    return this._http.get<Budgets>(url).pipe(catchError(this.handleError));
  }
  fetchBudget(id: number): Observable<Budget> {
    return this._http
      .get<Budget>(
        `${BASEURL}budgets/${id}?populate[client]=*&populate[media]=*&populate[service]=*&populate[notes][populate]=users_permissions_user&populate[contact_people]=*`
      )
      .pipe(
        map((response: Budget) => response.data),
        catchError(this.handleError)
      );
  }

  fetchLastBudget(): Observable<Budgets> {
    return this._http.get<Budgets>(
      `${BASEURL}budgets?sort=createdAt:desc&pagination[pageSize]=5`
    ).pipe(catchError(this.handleError));
  }

  addBudget(data: BudgetPayload): Observable<Budget> {
    return this._http.post<Budget>(`${BASEURL}budgets`, { data }).pipe(catchError(this.handleError));
  }

  updateBudget(id: number, data: any): Observable<Budget> {
    return this._http.put<Budget>(`${BASEURL}budgets/${id}`, { data }).pipe(catchError(this.handleError));
  }

  deleteBudget(id: number): Observable<any> {
    return this._http.delete<any>(`${BASEURL}budgets/${id}`).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'Error en el servicio de Presupuestos.';
    if (error.error && error.error.error && error.error.error.message) {
      errorMessage = error.error.error.message;
    } else if (error.message) {
      errorMessage = error.message;
    }
    console.error('BudgetService error:', errorMessage, error.error || error);
    return throwError(() => new Error(errorMessage));
  }
}
